import Litepicker from 'litepicker';
import { t } from '../../common/translations';
import {
  addDays,
  format,
  parse,
  daysDiff,
  verifyBlockedDates
} from '../../common/dates';
import { open as openMobileCalendarModal, close as closeMicroModal } from './modalHandler';
import { updateMobilePreview } from './summaryInfo';
import { datesToInputs, inputsToCalendar } from './datesHelpers';
import { getElement } from '../../common/asyncElementGetter';

let datePickCheckoutMobile = null;
let maxDate = null;
let datePickCheckinMobile = null;

async function modalReservationForm({ document }, { http }, searchDateFilter = false) {
  let preloadUrl = null;
  let minimumStay = null;
  let minDateParsed = null;
  let blockedCheckOutDatesList = [];
  let checkInEl = null;
  let checkOutEl = null;
  let checkInTextDivEl = null;
  let checkInTextEl = null;
  let checkInLabelEl = null;
  let checkOutTextDivEl = null;
  let checkOutTextEl = null;
  let checkOutLabelEl = null;
  let submitDatesButtonEl = null;
  let clearDatesButtonEl = null;
  let checkInTabEL = null;
  let checkOutTabEL = null;
  let minParsed = null;
  let searchedDatesCheckIn = null;
  let searchedDatesCheckOut = null;
  let moveIn = null;
  let moveOut = null;
  let useDates = 'normal';
  const today = new Date();
  let disabledMoveOutDates = [];
  const breakdownPropsEl = document.querySelector('#breakdown-props');
  const payByNight = breakdownPropsEl.getAttribute('data-pay-by-night');
  const oneDayOnly = breakdownPropsEl.getAttribute('data-stay_type') === 'one_day_only';

  if (!searchDateFilter) {
    const breakdownPropsEl = document.querySelector('#breakdown-props');
    preloadUrl = breakdownPropsEl.getAttribute('data-preload-url');
    minimumStay = parseInt(breakdownPropsEl.getAttribute('data-minimum-stay') || '0');
  }

  const locale = document.querySelector('html').getAttribute('lang');
  const checkInInput = document.querySelector('#search_check_in');
  const checkOutInput = document.querySelector('#search_check_out');
  const datesButton = await getElement('.select-dates', false, true, 500, 30);
  const bestdealDatesButton = await getElement('.select-bestdeal-dates', false, true, 500, 30);
  const withoutDatesButton = await getElement('.reservation-sticky-submit', false, true, 500, 30);
  const requestAutoSubmitButton = await getElement('.reservation-sticky-request-submit', false, true, 500, 30);
  const requestAutoSubmitButtonTrigger = await getElement('.reservation-sticky-request-submit-trigger', false, true, 500, 30);

  const createDatePicker = () => {
    minimumStay = parseInt(`${t('apartment_page.js.modal.minimum_stay')}`);
    document.querySelector('.check-out-container').classList.add('display-none');
    if (oneDayOnly) {
      document.querySelector('#check-out-tab').classList.add('display-none');
    }
    const datePickCheckinMobileEl = document.querySelector('#mobile-checkin-date');
    datePickCheckinMobile = new Litepicker({
      element: datePickCheckinMobileEl,
      inlineMode: true,
      singleMode: true,
      onSelect: function(date1) {
        selectCheckinDatesHandler({ dateCheckIn: date1, payByNight: payByNight, oneDayOnly: oneDayOnly });
      }
    });

    const datePickCheckoutMobileEl = document.querySelector('#mobile-checkout-date');
    datePickCheckoutMobile = new Litepicker({
      element: datePickCheckoutMobileEl,
      inlineMode: true,
      singleMode: true,
      onSelect: function(date2) {
        selectCheckoutDatesHandler(date2, payByNight);
      },
      onRender: function() {
        setTimeout(() => {
          disabledMoveOutDates.forEach(element => {
            const unixDate = Date.parse(element);
            if (document.querySelector('a[data-time="' + unixDate + '"]')) {
              document.querySelector('.check-out-container a[data-time="' + unixDate + '"]').classList.add('is-locked');
            }
          });
        }, 100);
      }
    });
    readElements(searchDateFilter);
    preloadMobile();
  };

  const selectCheckinDatesHandler = ({ dateCheckIn, payByNight, oneDayOnly }) => {
    const checkOut = datePickCheckoutMobile.getDate();
    const newMinDate = addDays(dateCheckIn, minimumStay);
    const newMaxDate = verifyBlockedDates(blockedCheckOutDatesList, dateCheckIn);
    checkInTextEl.innerText = format(dateCheckIn, 'D MMMM YYYY');
    moveIn = document.querySelector('.check_in');
    moveIn.classList.add('wrapper-adjust');
    datePickCheckoutMobile.setOptions({
      minDate: newMinDate,
      maxDate: newMaxDate
    });
    if (!checkOut || daysDiff(newMinDate, checkOut) < 0) {
      datePickCheckoutMobile.setOptions({
        startDate: newMinDate
      });
      document.querySelector('.check-in-container').classList.add('display-none');
      document.querySelector('.check-out-container').classList.remove('display-none');
      checkInEl.classList.remove('selected');
      checkInLabelEl.classList.add('display-none');
      checkInTextDivEl.classList.remove('display-none');
      checkOutLabelEl.classList.remove('display-none');
      checkOutTextDivEl.classList.add('display-none');
      checkOutEl.classList.add('selected');
      submitDatesButtonEl.disabled = true;
      datePickCheckoutMobile.clearSelection();
      minParsed = Date.parse(addDays(newMinDate, 14).toDateString());
      if (document.querySelector('.check-out-container a[data-time="' + minParsed + '"]')) {
        document.querySelector('.check-out-container a[data-time="' + minParsed + '"]').scrollIntoView(false);
      } else {
        minParsed = Date.parse(addDays(newMinDate).toDateString());
        if (document.querySelector('.check-out-container a[data-time="' + minParsed + '"]')) {
          document.querySelector('.check-out-container a[data-time="' + minParsed + '"]').scrollIntoView(false);
        }
      }

      if (!(payByNight === 'false')) {
        showCheckOutMessage();
      }

      if (searchDateFilter) {
        showReservationConfirmSubmit();
        submitDatesButtonEl.disabled = false;
      }
    }

    if (checkOutTextEl.innerHTML !== '') {
      checkOutLabelEl.classList.add('display-none');
    }
    document.querySelector('.check-in-container').classList.add('display-none');
    document.querySelector('.check-out-container').classList.remove('display-none');
    checkInEl.classList.remove('selected');
    checkInLabelEl.classList.add('display-none');
    checkInTextDivEl.classList.remove('display-none');
    checkOutEl.classList.add('selected');
    submitDatesButtonEl.disabled = true;
    minParsed = Date.parse(addDays(newMinDate, 14).toDateString());

    if (oneDayOnly) {
      datePickCheckoutMobile.setDate(datePickCheckinMobile.getDate());
      selectCheckoutDatesHandler(dateCheckIn, payByNight);
    }
  };

  const selectCheckoutDatesHandler = (dateCheckOut, payByNight) => {
    let sumPetfee = false;

    if (!(payByNight === 'false')) {
      showCheckOutMessage();
    }

    moveOut = document.querySelector('.check_out');
    moveOut.classList.add('wrapper-adjust');
    if (checkOutTextEl.innerText === '') sumPetfee = true;
    checkOutTextEl.innerText = format(dateCheckOut, 'D MMMM YYYY');
    checkOutLabelEl.classList.add('display-none');
    checkOutTextDivEl.classList.remove('display-none');
    checkInEl.classList.remove('selected');
    checkOutEl.classList.add('selected');
    if (!searchDateFilter) {
      document.querySelector('#will-moving-with-pet').checked = false;
      goToUpdateMobilePreview(sumPetfee);
    }
  };

  // select checkout date

  const checkScrollToMinDate = () => {
    if (minParsed && document.querySelector('.check-out-container a[data-time="' + minParsed + '"]')) {
      document.querySelector('.check-out-container a[data-time="' + minParsed + '"]').scrollIntoView(false);
    }
  };

  const readElements = (searchDateFilter) => {
    checkInEl = document.querySelector('#check-in-tab');
    checkOutEl = document.querySelector('#check-out-tab');
    checkInTextDivEl = document.querySelector('.calendar-range__selection-value-check_in');
    checkInTextEl = document.querySelector('.value_check_in');
    checkInLabelEl = document.querySelector('.select_check_in');
    checkOutTextDivEl = document.querySelector('.calendar-range__selection-value-check_out');
    checkOutTextEl = document.querySelector('.value_check_out');
    checkOutLabelEl = document.querySelector('.select_check_out');
    submitDatesButtonEl = document.querySelector('#reservation-confirm__submit');
    clearDatesButtonEl = document.querySelector('.clear-dates');
    const closeDatesModalBtnEl = document.querySelector('#close-calendar-modal');
    closeDatesModalBtnEl.removeEventListener('click', closeMicroModal);
    closeDatesModalBtnEl.addEventListener('click', closeMicroModal);
    clearDatesButtonEl.addEventListener('click', clearCalendarDates);
    submitDatesButtonEl.addEventListener('click', goToUpdateMobilePreview(false));
    checkInTabEL = document.querySelector('#check-in-tab');
    checkInTabEL.addEventListener('click', checkInTabHandler);
    checkOutTabEL = document.querySelector('#check-out-tab');
    checkOutTabEL.addEventListener('click', checkOutTabHandler({ payByNight }));
    const btnPrevMonthEl = document.querySelector('.check-out-container .button-previous-month');
    btnPrevMonthEl.addEventListener('click', checkScrollToMinDate);

    if (searchDateFilter) {
      const submitDatesButtonElText = document.querySelector('.submit_button_text');
      const submitWrapper = document.querySelector('.submit-wrapper');
      submitWrapper.classList.remove('display-none');
      submitDatesButtonElText.innerText = `${t('apartment_page.js.modal.apply')}`;
    }
  };

  const goToUpdateMobilePreview = (sumPetFee) => {
    if (datePickCheckinMobile.getDate() && datePickCheckoutMobile.getDate() && !searchDateFilter) {
      updateMobilePreview(datePickCheckinMobile.getDate(), datePickCheckoutMobile.getDate(), http, sumPetFee);
    }

    if (searchDateFilter) {
      const form = document.querySelector('.new_search');
      const checkIn = datePickCheckinMobile.getDate();
      const checkOut = datePickCheckoutMobile.getDate();
      const dates = { checkIn, checkOut };

      datesToInputs(dates, { checkInInput, checkOutInput });
      form.submit();
    }
  };

  const clearCalendarDates = () => {
    document.querySelector('.check-out-container').classList.add('display-none');
    document.querySelector('.check-in-container').classList.remove('display-none');
    checkInLabelEl.classList.remove('display-none');
    checkInTextDivEl.classList.add('display-none');
    moveIn = document.querySelector('.check_in');
    moveOut = document.querySelector('.check_out');
    moveIn.classList.remove('wrapper-adjust');
    moveOut.classList.remove('wrapper-adjust');
    datePickCheckinMobile.clearSelection();
    datePickCheckoutMobile.clearSelection();
    showCheckInMessage();
    document.querySelector('.datepicker-loader').style.display = 'none';
    if (minParsed) {
      document.querySelector('a[data-time="' + minDateParsed + '"]').scrollIntoView(false);
    }
    checkOutEl.classList.remove('selected');
    checkInEl.classList.add('selected');
    checkOutLabelEl.classList.remove('display-none');
    checkOutTextDivEl.classList.add('display-none');
  };

  const preloadMobile = async() => {
    let blockedCheckInDatesList = [];
    let maxCheckInDate = null;
    let minCheckInDate = null;
    let disableWeekends = null;

    if (!searchDateFilter) {
      const { data: { max_check_in_date: _maxCheckInDate, min_check_in_date: _minCheckInDate, blocked_checkin_dates_list: _blockedCheckInDatesList, blocked_checkout_dates_list: _blockedCheckOutDatesList, disable_weekends: _disableWeekends, disabled_move_out_dates: _disabledMoveOutDates } } = await http.get(preloadUrl);
      maxCheckInDate = _maxCheckInDate;
      minCheckInDate = _minCheckInDate;
      blockedCheckInDatesList = _blockedCheckInDatesList;
      blockedCheckOutDatesList = _blockedCheckOutDatesList;
      maxDate = maxCheckInDate;
      disableWeekends = _disableWeekends;
      disabledMoveOutDates = _disabledMoveOutDates;
    } else {
      const searchedDates = inputsToCalendar({ checkInInput, checkOutInput });
      searchedDatesCheckIn = searchedDates.checkIn;
      searchedDatesCheckOut = searchedDates.checkOut;
      if (searchedDatesCheckIn) {
        selectCheckinDatesHandler(searchedDatesCheckIn);
      }

      if (searchedDatesCheckOut) {
        selectCheckoutDatesHandler(searchedDatesCheckOut);
      }

      checkInTabHandler();
    }

    minDateParsed = Date.parse(minCheckInDate + ' 00:00:00');

    datePickCheckinMobile.setOptions({
      lang: locale,
      numberOfMonths: 2,
      numberOfColumns: 1,
      hotelMode: true,
      firstDay: 0,
      startDate: minCheckInDate,
      mobileFriendly: true,
      minDate: minCheckInDate,
      maxDate: maxDate,
      bookedDays: blockedCheckInDatesList
    });

    datePickCheckoutMobile.setOptions({
      lang: locale,
      numberOfMonths: 2,
      numberOfColumns: 1,
      hotelMode: true,
      firstDay: 0,
      startDate: searchedDatesCheckOut,
      minDate: addDays(today, minimumStay),
      mobileFriendly: true,
      bookedDays: blockedCheckOutDatesList,
      disableWeekends: disableWeekends
    });
    showCheckInMessage();
    document.querySelector('.mobile-calendar-modal').style.display = 'block';
    if (minDateParsed) {
      document.querySelector('a[data-time="' + minDateParsed + '"]').scrollIntoView(false);
      document.querySelector('a[data-time="' + minDateParsed + '"]').classList.remove('is-start-date', 'is-end-date');
    }

    if (!searchDateFilter) applyCheckInCheckOutDatesIfExisten();
  };

  const applyCheckInCheckOutDatesIfExisten = () => {
    let presetCheckInString = '';
    let presetCheckOutString = '';

    switch (useDates) {
    case 'best_deal':
      presetCheckInString = breakdownPropsEl.getAttribute('data-min-price-check-in-date');
      presetCheckOutString = breakdownPropsEl.getAttribute('data-min-price-check-out-date');
      break;
    case 'normal':
      presetCheckInString = breakdownPropsEl.getAttribute('data-preset-start-date');
      presetCheckOutString = breakdownPropsEl.getAttribute('data-preset-end-date');
      break;
    default:
      break;
    }

    if (presetCheckInString.length > 0) {
      datePickCheckinMobile.setDate(parse(presetCheckInString), false);
      datePickCheckinMobile.gotoDate(parse(presetCheckInString));
    }

    if (presetCheckOutString.length > 0) {
      datePickCheckoutMobile.setDate(parse(presetCheckOutString), false);
      datePickCheckoutMobile.gotoDate(parse(presetCheckOutString));
    }

    goToUpdateMobilePreview(false);
  };

  const handleSeeDatesButton = () => {
    useDates = 'normal';
    openMobileCalendarModal({});
    createDatePicker();
  };

  const handleSeeBestDealDatesButton = () => {
    useDates = 'best_deal';
    openMobileCalendarModal({});
    createDatePicker();
  };

  const handleSeeWithoutDatesButton = () => {
    useDates = 'none';
    openMobileCalendarModal({});
    createDatePicker();
  };

  const handleRequestAutoSubmitButton = () => {
    useDates = 'normal';
    requestAutoSubmitButtonTrigger.innerHTML = 'true';
    openMobileCalendarModal({});
    createDatePicker();
  };

  datesButton.addEventListener('click', handleSeeDatesButton);
  bestdealDatesButton.addEventListener('click', handleSeeBestDealDatesButton);
  withoutDatesButton.addEventListener('click', handleSeeWithoutDatesButton);
  requestAutoSubmitButton.addEventListener('click', handleRequestAutoSubmitButton);

  if (!!breakdownPropsEl.getAttribute('data-preset-start-date') && !!breakdownPropsEl.getAttribute('data-preset-end-date') && datesButton) {
    datesButton.click();
  }
}

const checkInTabHandler = () => {
  showCheckInMessage();
  const checkInEl = document.querySelector('#check-in-tab');
  const checkOutEl = document.querySelector('#check-out-tab');
  document.querySelector('.check-out-container').classList.add('display-none');
  document.querySelector('.check-in-container').classList.remove('display-none');
  checkOutEl.classList.remove('selected');
  checkInEl.classList.add('selected');
  showReservationConfirmSubmit();
};

const checkOutTabHandler = ({ payByNight }) => {
  if (!(payByNight === 'false')) {
    showCheckOutMessage();
  }
  const checkOutDate = datePickCheckinMobile.getDate();
  showReservationConfirmSubmit();
  if (checkOutDate) {
    const checkInEl = document.querySelector('#check-in-tab');
    const checkOutEl = document.querySelector('#check-out-tab');
    document.querySelector('.check-out-container').classList.remove('display-none');
    document.querySelector('.check-in-container').classList.add('display-none');
    checkOutEl.classList.add('selected');
    checkInEl.classList.remove('selected');
    const checkOutParsed = Date.parse(checkOutDate.toDateString());
    if (document.querySelector('.check-out-container a[data-time="' + checkOutParsed + '"]')) {
      document.querySelector('.check-out-container a[data-time="' + checkOutParsed + '"]').scrollIntoView(false);
    }
  }
};

const showReservationConfirmSubmit = () => {
  const confirmButton = document.querySelector('#reservation-confirm__submit');
  confirmButton.classList.remove('display-none');
};

const showCheckInMessage = () => {
  document.querySelector('.property-booking-bar__messages').innerText = maxDate == null ? `${t('apartment_page.js.modal.check_in_info_filter')}` : `${t('apartment_page.js.modal.check_in_info')} ${format(maxDate, 'L')}`;
  document.querySelector('.property-booking-bar__messages').classList.remove('display-none');
};

const showCheckOutMessage = () => {
  document.querySelector('.property-booking-bar__messages').innerText = `${t('apartment_page.js.modal.min_stay')}`;
  document.querySelector('.property-booking-bar__messages').classList.remove('display-none');
};

export default modalReservationForm;

export function goToCheckInTab() {
  document.querySelector('#preview_modal_body').classList.add('display-none');
  document.querySelector('#dates_modal_body').classList.remove('display-none');
  checkInTabHandler();
}

export function goToCheckOutTab() {
  document.querySelector('#preview_modal_body').classList.add('display-none');
  document.querySelector('#dates_modal_body').classList.remove('display-none');
  checkOutTabHandler();
}
